import { useState, useRef } from "react";
import "./editorialForms.css";

const categories = [
  { id: "outfit", name: "Look Completo" },
  { id: "accessory", name: "Acessório" },
  { id: "shoes", name: "Calçados" },
  { id: "bag", name: "Bolsa" },
  { id: "jewelry", name: "Jóias/Bijuterias" },
  { id: "trend", name: "Tendência" },
];

const occasions = [
  "Casual",
  "Trabalho",
  "Festa",
  "Casamento",
  "Praia",
  "Esporte",
  "Data",
  "Entrevista",
  "Viagem",
  "Festival",
];

const seasons = ["Verão", "Inverno", "Primavera", "Outono", "Meia-estação"];

const styles = [
  "Casual",
  "Formal",
  "Streetwear",
  "Vintage",
  "Minimalista",
  "Boho",
  "Elegante",
  "Esportivo",
  "Rock",
  "Romântico",
];

export default function FashionForm({ data, onChange }) {
  const fileInputRef = useRef(null);
  const [itemInput, setItemInput] = useState({
    name: "",
    brand: "",
    price: "",
    link: "",
  });
  const [colorInput, setColorInput] = useState("");
  const [photoPreviews, setPhotoPreviews] = useState(data?.photos || []);

  const handleAddItem = () => {
    if (itemInput.name.trim()) {
      onChange({
        ...data,
        items: [
          ...(data?.items || []),
          {
            name: itemInput.name.trim(),
            brand: itemInput.brand.trim(),
            price: parseFloat(itemInput.price) || 0,
            link: itemInput.link.trim(),
          },
        ],
      });
      setItemInput({ name: "", brand: "", price: "", link: "" });
    }
  };

  const handleRemoveItem = (index) => {
    onChange({
      ...data,
      items: (data?.items || []).filter((_, i) => i !== index),
    });
  };

  const handleToggleOccasion = (occasion) => {
    const current = data?.occasion || [];
    if (current.includes(occasion)) {
      onChange({
        ...data,
        occasion: current.filter((o) => o !== occasion),
      });
    } else {
      onChange({
        ...data,
        occasion: [...current, occasion],
      });
    }
  };

  const handleToggleSeason = (season) => {
    const current = data?.season || [];
    if (current.includes(season)) {
      onChange({
        ...data,
        season: current.filter((s) => s !== season),
      });
    } else {
      onChange({
        ...data,
        season: [...current, season],
      });
    }
  };

  const handleAddColor = () => {
    if (colorInput.trim()) {
      onChange({
        ...data,
        colors: [...(data?.colors || []), colorInput.trim()],
      });
      setColorInput("");
    }
  };

  const handleRemoveColor = (index) => {
    onChange({
      ...data,
      colors: (data?.colors || []).filter((_, i) => i !== index),
    });
  };

  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const maxPhotos = 10;
    const currentPhotos = photoPreviews.length;
    const availableSlots = maxPhotos - currentPhotos;

    if (availableSlots <= 0) {
      alert("Você pode adicionar no máximo 10 fotos");
      return;
    }

    const filesToAdd = files.slice(0, availableSlots);
    const newPreviews = [];

    filesToAdd.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newPreviews.push(reader.result);
        if (newPreviews.length === filesToAdd.length) {
          const updatedPhotos = [...photoPreviews, ...newPreviews];
          setPhotoPreviews(updatedPhotos);
          onChange({ ...data, photos: updatedPhotos });
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemovePhoto = (index) => {
    const updatedPhotos = photoPreviews.filter((_, i) => i !== index);
    setPhotoPreviews(updatedPhotos);
    onChange({ ...data, photos: updatedPhotos });
  };

  const handleToggleStyle = (style) => {
    const current = data?.style || [];
    if (current.includes(style)) {
      onChange({
        ...data,
        style: current.filter((s) => s !== style),
      });
    } else {
      onChange({
        ...data,
        style: [...current, style],
      });
    }
  };

  return (
    <div className="editorial_form fashion_form">
      {/* Upload de Fotos */}
      <div className="editorial_form_section">
        <label>
          Fotos do Look <span className="required">*</span>
          <span style={{ fontSize: "12px", color: "var(--color-secondary)", marginLeft: "8px" }}>
            ({photoPreviews.length}/10 fotos)
          </span>
        </label>
        <input
          type="file"
          ref={fileInputRef}
          multiple
          accept="image/*"
          style={{ display: "none" }}
          onChange={handlePhotoUpload}
        />
        <div className="fashion_photo_upload">
          {photoPreviews.map((photo, index) => (
            <div key={index} className="fashion_photo_preview">
              <img src={photo} alt="" />
              <button
                type="button"
                className="remove_photo_btn"
                onClick={() => handleRemovePhoto(index)}
              >
                ×
              </button>
            </div>
          ))}
          <button
            type="button"
            className="add_photo_btn"
            onClick={() => fileInputRef.current?.click()}
          >
            + Adicionar Foto
          </button>
        </div>
      </div>

      {/* Título */}
      <div className="editorial_form_section">
        <label>Título do Look <span className="required">*</span></label>
        <input
          type="text"
          placeholder="Ex: Look de Verão para o Escritório"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva o look, dicas de combinação, inspiração..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Estilo</label>
          <input
            type="text"
            placeholder="Ex: Minimalista, Streetwear, Boho..."
            value={(data?.style || []).join(", ")}
            onChange={(e) =>
              onChange({
                ...data,
                style: e.target.value.split(",").map((s) => s.trim()).filter(Boolean),
              })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Ocasião</label>
        <div className="genre_chips">
          {occasions.map((occasion) => (
            <span
              key={occasion}
              className={`genre_chip ${
                (data?.occasion || []).includes(occasion) ? "selected" : ""
              }`}
              onClick={() => handleToggleOccasion(occasion)}
            >
              {occasion}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Estação</label>
        <div className="genre_chips">
          {seasons.map((season) => (
            <span
              key={season}
              className={`genre_chip ${
                (data?.season || []).includes(season) ? "selected" : ""
              }`}
              onClick={() => handleToggleSeason(season)}
            >
              {season}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Cores do Look</label>
        <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
          <input
            type="text"
            placeholder="Ex: Preto, Branco, Terracota..."
            value={colorInput}
            onChange={(e) => setColorInput(e.target.value)}
            style={{ flex: 1 }}
          />
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddColor}
          >
            + Adicionar
          </button>
        </div>
        <div className="genre_chips">
          {(data?.colors || []).map((color, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveColor(i)}
              style={{ cursor: "pointer" }}
            >
              {color} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Peças do Look
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddItem}
          >
            + Adicionar
          </button>
        </label>
        <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
          <input
            type="text"
            placeholder="Peça"
            value={itemInput.name}
            onChange={(e) =>
              setItemInput({ ...itemInput, name: e.target.value })
            }
            style={{ flex: 2 }}
          />
          <input
            type="text"
            placeholder="Marca"
            value={itemInput.brand}
            onChange={(e) =>
              setItemInput({ ...itemInput, brand: e.target.value })
            }
            style={{ flex: 1 }}
          />
          <input
            type="number"
            placeholder="Preço"
            value={itemInput.price}
            onChange={(e) =>
              setItemInput({ ...itemInput, price: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
        </div>
        <input
          type="url"
          placeholder="Link para compra (opcional)"
          value={itemInput.link}
          onChange={(e) => setItemInput({ ...itemInput, link: e.target.value })}
          style={{ marginBottom: "8px" }}
        />
        {(data?.items || []).length > 0 && (
          <div style={{ marginTop: "8px" }}>
            {data.items.map((item, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  background: "var(--bg-third)",
                  borderRadius: "6px",
                  marginBottom: "4px",
                }}
              >
                <span>
                  <strong>{item.name}</strong>
                  {item.brand && ` - ${item.brand}`}
                  {item.price > 0 && ` (R$${item.price})`}
                </span>
                <button
                  type="button"
                  className="remove_variant_btn"
                  onClick={() => handleRemoveItem(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="editorial_form_section">
        <label>Marcas Mencionadas</label>
        <input
          type="text"
          placeholder="Ex: Zara, Renner, Farm (separadas por vírgula)"
          value={(data?.brands || []).join(", ")}
          onChange={(e) =>
            onChange({
              ...data,
              brands: e.target.value.split(",").map((b) => b.trim()).filter(Boolean),
            })
          }
        />
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isAffordable"
            checked={data?.isAffordable || false}
            onChange={(e) =>
              onChange({ ...data, isAffordable: e.target.checked })
            }
          />
          <label htmlFor="isAffordable">Look acessível / Custo-benefício</label>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Estilo</label>
        <div className="genre_chips">
          {styles.map((style) => (
            <span
              key={style}
              className={`genre_chip ${
                (data?.style || []).includes(style) ? "selected" : ""
              }`}
              onClick={() => handleToggleStyle(style)}
            >
              {style}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
        </svg>
        <span>
          Marque as peças nas fotos para facilitar a compra pelos seguidores!
        </span>
      </div>
    </div>
  );
}
